
import EDPanel from '../../../../../BaseComponents/Panel/EDPanel';
import Logger from '../../../../../Utils/Logger';

interface IProps {
  children?: React.ReactNode;
}

const notImplemented = (name: string) => (props: IProps) => {
  let compProps;
  try {
    compProps = JSON.stringify(props, null, 2);
  } catch (err) {
    Logger.info('Not Implemented: ' + name, props);
    compProps = props.toString();
  }
  return (
    <EDPanel title={`${name} (inte implementerad)`}>
      <pre>{compProps}</pre>
      {props.children}
    </EDPanel>
  );
};

/**
Ett exempel som använder notImplemented för att visa att en komponent inte har blivit implementerad än
*/
export const UnimplementedComponent = (props: IProps) => {
  const Component = notImplemented('UnimplementedComponent');
  return <Component {...props} />;
};

export default notImplemented;
